export default "__VITE_ASSET__DH_ilLh___"